import { Card, Container, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { useState, cloneElement, useRef, useEffect } from 'react';

import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import EventsListView from './EventsListView';

import { RedOutlinedButton } from '../Buttons';
import { DecisionDialog } from '../DecisionDialog';

import { usePopup } from '../../context/PopupContext';

import API from '../../api';
import { HttpErrorHandler } from '../ErrorHandler';

export default function EventPageLayout({
  children,
  isAdmin,
  hasAuth,
  celebrations,
  getCelebrations,
  events,
  getEvents,
}) {
  const [btnGroupValue, setBtnGroupValue] = useState('calendar');

  useEffect(() => {
    const savedValue = localStorage.getItem('btnGroupValue');
    if (savedValue === 'list' || savedValue === 'calendar') {
      setBtnGroupValue(savedValue);
    }
  }, []);

  const handleChangeBtnGroupValue = (event, newBtnGroupValue) => {
    setBtnGroupValue(newBtnGroupValue);
    localStorage.setItem('btnGroupValue', newBtnGroupValue);
  };

  /* -------------------------------- Popup -------------------------------- */

  const { showPopup, setPopUpText } = usePopup();

  /* ----------------------------- // Delete Event ---------------------------- */

  const [openDeleteEventDialog, setOpenDeleteEventDialog] = useState(false);
  const [eventToDelete, setEventToDelete] = useState({});

  // open delete calendar event dialog
  const handleOpenDeleteEventDialog = (event) => {
    setEventToDelete(event);
    setOpenDeleteEventDialog(true);
  };

  // close delete calendar event dialog
  const handleCloseDeleteEventDialog = () => {
    setEventToDelete({});
    setOpenDeleteEventDialog(false);
  };

  // Delete an event request
  const onDeleteEvent = () => {
    const eventType = eventToDelete.type;

    const url = eventType === 'event' ? `/events/${eventToDelete.id}` : `/celebrations/${eventToDelete.id}`;

    API.delete(url)
      .then((response) => {
        // handleCloseDetailEventDialog();
        handleCloseDeleteEventDialog();

        if (eventType === 'event') {
          getEvents();
        } else {
          getCelebrations();
        }

        showPopup(true, response.data.message);
      })
      .catch((error) => {
        HttpErrorHandler(error, setPopUpText);
        showPopup(false);
      });
  };

  return (
    <>
      <Helmet>
        <title>Eventi</title>
      </Helmet>
      <Container maxWidth="xl">
        <Card sx={{ padding: '12px', marginBottom: '12px', width: 'fit-content' }}>
          <ToggleButtonGroup value={btnGroupValue} exclusive onChange={handleChangeBtnGroupValue}>
            <ToggleButton value="list" aria-label="list view">
              <FormatListBulletedIcon />
            </ToggleButton>
            <ToggleButton value="calendar" aria-label="calendar view">
              <CalendarMonthIcon />
            </ToggleButton>
          </ToggleButtonGroup>
        </Card>

        {btnGroupValue === 'list' ? (
          <>
            <EventsListView
              isAdmin={isAdmin}
              hasAuth={hasAuth}
              celebrations={celebrations}
              events={events}
              openDeleteEvent={handleOpenDeleteEventDialog}
            />
          </>
        ) : (
          <Card sx={{ p: '24px' }}>
            {cloneElement(children, {
              isAdmin,
              hasAuth,
              celebrations,
              events,
            })}
          </Card>
        )}

      </Container>

      <DecisionDialog
        openDialog={openDeleteEventDialog}
        dialogTitle="Eliminazione evento"
        dialogDescription={
          <>
            Sei sicuro di voler eliminare l'evento {eventToDelete.title}? <br />
            Verranno eliminate anche tutte le date e gli stand ad esso relazionati.
          </>
        }
        closeOperation={handleCloseDeleteEventDialog}
        requestOperation={onDeleteEvent}
        requestText={'Elimina'}
        closeText={'Chiudi'}
        RequestButton={RedOutlinedButton}
      />
    </>
  );
}
